import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/layout/LandingPage/LandingNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/layout/Language/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/layout/RightNav/RightNavbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/components/shared/link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
